import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { Location } from "../models/location"; 
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core'
import { map } from "rxjs/operators";
import { HttpClient, JsonpClientBackend } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  apiEndpoint: string;
  baseApiUrl: any;
  apiUniqueId: string = 'location/id/d32a6cc9-353b-4e23-90fb-3c410cd6fd7e/';

  constructor(private httpService: HttpWrapperService, private http: HttpClient,
    private configService: ConfigService
  ) {
    this.apiEndpoint = this.configService.getConfigValue('apiEndpoint');
    this.apiEndpoint += this.apiUniqueId;
  }

  getAllLocations(filter: string, pagesize: number, pagenumber: number,filterType : number,filterData: number): Observable<Array<Location>> { 
    return this.httpService.get(this.apiEndpoint + 'getAllLocations?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)+ '&filterType=' + (filterType ? filterType : 0)+ '&filterData=' + (filterData ? filterData : 0)).pipe(map((result: any) => {                         
      if (result.Success) {        
        return result.Data;
      } else {
        return [];
      }
    }));
  } 
  viewLocation(LocationID?: string): Observable<Array<Location>> {
    return this.httpService.get(this.apiEndpoint + 'viewLocation/' + (LocationID ? LocationID : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  saveLocation(locations: Location): Observable<any> { 
    return this.httpService.post(this.apiEndpoint + 'saveLocation/', locations).pipe(map((result: any) => {
      if (result.Success) { 
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  checkEmail(Emailid?: string, LocationId?: string): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'checkEmail?Emailid=' + (Emailid ? Emailid : '')+ '&LocationId=' + (LocationId ? LocationId : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
      return result;
    })); 
  }

  deleteLocation(LocationID?: string): Observable<any> {
    return this.httpService.post(this.apiEndpoint + 'deleteLocation/' + (LocationID ? LocationID : '00000000-0000-0000-0000-000000000000'), LocationID).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  checkDuplication(LocationId?: string,Code?: string): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'checkDuplication?&LocationId=' + (LocationId ? LocationId : '00000000-0000-0000-0000-000000000000')+'&Code=' + (Code ? Code : '')).pipe(map((result: any) => {
        return result; 
    }));
  }
}
